import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { ListOpenQuoteWrapper } from '@app/pages/quote/open-quote/list-open-quote/list-open-quote-wrapper.component';
@Component({
  selector: 'app-list-open-quote',
  templateUrl: './list-open-quote.component.html',
  styleUrls: ['./list-open-quote.component.scss'],
})
export class ListOpenQuoteComponent extends ListOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }

  clients_mock = [
    {
      label: 'Juan Perez',
      id: '1234567890'
    },
    {
      label: 'Maria Gomez',
      id: '1234567890'
    },
  ]
}
